import { useTranslation } from 'react-i18next'

import { type IMediaSearchResult } from 'types/interfaces/IMediaSearchResult'
import { type ISearchResult } from 'types/interfaces/ISearchResult'
import { type ListFilter } from 'types/types'

import Basic from './types/Basic'
import SearchWithButtons from './types/SearchWIthButtons'
import SearchWithTitle from './types/SearchWithTitle'
import TitleWithButtons from './types/TitleWithButtons'
import TitleWithButtonsNoIcon from './types/TitleWithButtonsNoIcon'
import WithDots from './types/WithDots'
import WithInfo from './types/WithInfo'
import WithSwitch from './types/WithSwitch'

import './_layoutHeader.scss'

type LayoutHeaderProps = {
    type: string
    section?: string
    title?: string
    titleWithIcon?: JSX.Element
    switchActive?: boolean
    switchFn?: any
    info?: string
    dots?: any[]
    searchValue?: string
    searchFn?: any
    searchResults?: {
        resultsType: string
        resultsData: ISearchResult[]
    }
    mediaSearchResults?: IMediaSearchResult
    additionalProps?: any
    sortingProps?: {
        selectedSort: string
        selectedOrder: string
        selectProps?: Record<string | number, string | number>
        selectedRemovedMedia?:any
        showRemoveMedia?:boolean
        selectedShowDuplicates?: string // ← add this
        selectedGroupByPost?: string 
    }
    defaultOrderBySort?: Record<string, string>
    buttons?: ListFilter[] | any
    applyFn?: any
    selectFn?: (value: string, id?: number) => void
    clearFn?: () => void
    searchSettings?: {
        isForm?: boolean
        iconClickFn?: () => void
        formSubmitFn?: (e: any) => void
        hideIconOnMobile?: boolean
    }
    buttonSize?: string
}

const LayoutHeader = ({
    type,
    section,
    title,
    titleWithIcon,
    switchActive,
    switchFn,
    info,
    dots,
    searchValue,
    searchFn,
    searchResults,
    mediaSearchResults,
    additionalProps,
    sortingProps,
    buttons,
    applyFn,
    selectFn,
    clearFn,
    searchSettings,
    buttonSize,
    defaultOrderBySort
}: LayoutHeaderProps) => {
    const { t } = useTranslation()

    const translatedTitle = t(title ?? '')
    const translatedSection = t(section ?? '')
    if (type === 'basic') {
        return <Basic section={translatedSection} title={translatedTitle} />
    } else if (type === 'switch') {
        return (
            <WithSwitch
                section={translatedSection}
                title={translatedTitle}
                switchActive={switchActive}
                switchFn={switchFn}
            />
        )
    } else if (type === 'dots') {
        return (
            <WithDots
                section={translatedSection}
                title={translatedTitle}
                dots={dots}
            />
        )
    } else if (type === 'info') {
        return (
            <WithInfo
                section={translatedSection}
                title={translatedTitle}
                info={info}
            />
        )
    } else if (type === 'search-with-title') {
        return (
            <SearchWithTitle
                title={translatedTitle}
                searchValue={searchValue}
                searchFn={searchFn}
                clearFn={clearFn}
                additionalProps={additionalProps}
                searchSettings={searchSettings}
            />
        )
    } else if (type === 'search-with-buttons') {
        return (
            <SearchWithButtons
                searchValue={searchValue}
                searchFn={searchFn}
                additionalProps={additionalProps}
                sortingProps={sortingProps}
                buttons={buttons}
                applyFn={applyFn}
                selectFn={selectFn}
                clearFn={clearFn}
                searchResults={searchResults}
                mediaSearchResults={mediaSearchResults}
                searchSettings={searchSettings}
                defaultOrderBySort={defaultOrderBySort}
            />
        )
} else if (type === 'title-with-buttons') {
  return (
<TitleWithButtons
  titleWithIcon={titleWithIcon}
  buttons={buttons}
  applyFn={applyFn}
  sortingProps={
    sortingProps
      ? {
          selectedSort: sortingProps.selectedSort,
          selectedOrder: sortingProps.selectedOrder,
          selectProps: sortingProps.selectProps as Record<string, string | number> | undefined,
          selectedRemovedMedia: !!sortingProps.selectedRemovedMedia,
          selectedShowDuplicates:
            sortingProps.selectedShowDuplicates?.toString() === 'true',
        }
      : undefined
  }
/>
  )
} else if (type === 'title-with-buttons-no-icon') {
  return (
    <TitleWithButtonsNoIcon
      title={translatedTitle}
      buttons={buttons}
      buttonSize={buttonSize}
      applyFn={applyFn}
      sortingProps={sortingProps}
    />
        )
    } else {
        return null
    }
}

export default LayoutHeader
